export default __webpack_public_path__ + "resources/icons/n340-4206.webp";